import React, { useCallback } from 'react';

import { styled, css } from '@compiled/react';
import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';
import { token } from '@atlaskit/tokens';
import type { Command } from '@atlassian/jira-command-palette';
import { useTransformNavigationCommands } from '@atlassian/jira-command-palette-common';
import type { ViewAllCommandProps } from './types';

export const useGetViewAllCommand = () => {
	const { transformNavigationCommand } = useTransformNavigationCommands();

	const getViewAllCommand = useCallback(
		({
			name,
			url,
			isRecommended = false,
			analyticsPayload = {},
			...rest
		}: ViewAllCommandProps): Command =>
			transformNavigationCommand(
				{
					name,
					components: {
						Name: () => (
							<RenderNameWrapper
								data-testid="command-palette-quick-search.common.ui.view-all.render-name-wrapper"
								isRecommended={isRecommended}
							>
								{name}
							</RenderNameWrapper>
						),
						LeftIcon: () => <ArrowRightIcon label="" />,
					},
					analytics: {
						action: 'quickSearchViewAll',
						...analyticsPayload,
					},
					...rest,
				},
				{ path: url },
			),
		[transformNavigationCommand],
	);

	return { getViewAllCommand };
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RenderNameWrapper = styled.div<{ isRecommended: boolean }>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isRecommended }) =>
		!isRecommended &&
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		css({
			color: token('color.text.brand', '#0C66E4'),
		}),
);
